import spinners from "@components/loader/spinners"

export default function MapOverlay(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this

    this.generate = () =>{
        
    }

    this.update = () =>{

    }

    this.show = () =>{
        $('.overlay-container').show()
    }

    this.hide = () =>{
        $('.overlay-container').hide()
    }

    init()

    function init(){
        $('.overlay-container').html(spinners.defaultSpinner(1, 'var(--dark)'))
    }
}

MapOverlay.prototype = Object.create(BaseConstructor.prototype)